import type { MailboxInfo } from "owa-client-types";
import copilotSettingsStore from "../store/store";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { LicenseType } from "../services/types/serviceSettingTypes";

export function isSalesLicensePresent(mailboxInfo: MailboxInfo): boolean {
    return (copilotSettingsStore(mailboxInfo).licenses.indexOf(LicenseType.SalesCopilot) >= 0 ||
        isGlobalFeatureEnabled("mon-copilot-ext-debug-addins"));
}
